/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Login_Page_Code_DescriptionInputs */

const en_login_page_code_description = /** @type {(inputs: Login_Page_Code_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent a six-digit code to ${i?.email}.`)
};

const de_login_page_code_description = /** @type {(inputs: Login_Page_Code_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wir haben einen sechsstelligen Code an ${i?.email} gesendet.`)
};

const pt_br2_login_page_code_description = /** @type {(inputs: Login_Page_Code_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviamos um código de seis dígitos para ${i?.email}.`)
};

const tr_login_page_code_description = /** @type {(inputs: Login_Page_Code_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} adresine altı haneli bir kod gönderdik.`)
};

const zh_cn2_login_page_code_description = /** @type {(inputs: Login_Page_Code_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我们已向 ${i?.email} 发送了六位验证码。`)
};

const zh_hk2_login_page_code_description = /** @type {(inputs: Login_Page_Code_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我們已向 ${i?.email} 傳送六位驗證碼。`)
};

const ko_kr2_login_page_code_description = /** @type {(inputs: Login_Page_Code_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email}(으)로 6자리 코드를 보냈습니다.`)
};

const ru_ru2_login_page_code_description = /** @type {(inputs: Login_Page_Code_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Мы отправили шестизначный код на адрес ${i?.email}.`)
};

const es_419_login_page_code_description = /** @type {(inputs: Login_Page_Code_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviamos un código de seis dígitos a ${i?.email}.`)
};

/**
* | output |
* | --- |
* | "We sent a six-digit code to {email}." |
*
* @param {Login_Page_Code_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_code_description = /** @type {((inputs: Login_Page_Code_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Code_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_code_description(inputs)
	if (locale === "de") return de_login_page_code_description(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_code_description(inputs)
	if (locale === "tr") return tr_login_page_code_description(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_code_description(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_code_description(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_code_description(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_code_description(inputs)
	return es_419_login_page_code_description(inputs)
});